import { render, staticRenderFns } from "./DownloadPrompt.vue?vue&type=template&id=dc8994c2&"
import script from "./DownloadPrompt.vue?vue&type=script&lang=js&"
export * from "./DownloadPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports